<section [ngClass]="className">
  <div>
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.24506 14.2413C11.5568 14.2413 14.2415 11.5567 14.2415 8.24494C14.2415 4.93321 11.5568 2.24854 8.24506 2.24854C4.93334 2.24854 2.24866 4.93321 2.24866 8.24494C2.24866 11.5567 4.93334 14.2413 8.24506 14.2413Z" stroke="#D1D5DB" stroke-width="1.34919"/>
      <path d="M15.7405 15.7405L12.48 12.48" stroke="#D1D5DB" stroke-width="1.34919"/>
    </svg>
  </div>

  <h6><ng-content></ng-content></h6>

<!--  <small>Try adjusting your search or filters</small>-->
</section>
